import React from 'react'
import { Tooltip, TooltipTrigger } from 'chemistry'
import Collapsible from '../Collapsible/Collapsible'
import { useCollapsible } from 'client/fragments/listerFragment/components/Filters/Collapsible/useCollapsible'
import { AnimatePresence } from 'framer-motion'
import { CheckListFilterItems } from './CheckListFilterItems'
import { getId } from 'client/fragments/listerFragment/components/Filters/utilsFilters'

export const modifyOffset = ({ placement, reference, popper }) => {
  if (placement === 'bottom') {
    const bottomOffset = 28
    const tooltipSize = popper.height
    const viewportHeight = window.innerHeight
    const elementDistanceToTop = reference.y
    const distanceToViewportBottom = viewportHeight - (tooltipSize + elementDistanceToTop + bottomOffset)

    if (distanceToViewportBottom < 0) {
      return [0, distanceToViewportBottom + 12 /* compensate bottom offset */]
    }
    return [0, bottomOffset]
  }
  return []
}

export const CheckListFilter = ({
  filter: { description, ...filter },
  onChange,
  onHintClick,
  format,
  lang,
  buttonActiveText,
  buttonInactiveText
}) => {
  const { isCollapsed, setIsCollapsed } = useCollapsible()

  const accessibilityId = getId(`clps_${filter.name}`)

  return (
    <Collapsible
      isCollapsed={isCollapsed}
      setIsCollapsed={setIsCollapsed}
      dataTestId='checklist'
      dataValue={filter.name}
    >
      <Collapsible.Header htmlFor={accessibilityId}>
        {filter.title}
        {description && (
          <Tooltip
            fontSize='xs'
            color='black.200'
            content={description}
            modifiers={[
              {
                name: 'tooltipPositionLogger',
                enabled: true,
                phase: 'beforeRead',
                fn: ({ state }) => {
                  const elementDistanceToTop = state?.elements?.reference?.getBoundingClientRect().top
                  const tooltipSize = state?.elements?.popper?.clientHeight

                  if (elementDistanceToTop < tooltipSize) {
                    state.placement = 'bottom'
                  }
                }
              },
              {
                name: 'offset',
                options: {
                  offset: modifyOffset
                }
              }
            ]}
            onClick={e => {
              onHintClick(filter.name)
              e.preventDefault()
              e.stopPropagation()
            }}
          >
            <TooltipTrigger mt='2px' />
          </Tooltip>
        )}
      </Collapsible.Header>
      <AnimatePresence initial={false}>
        {!isCollapsed && (
          <Collapsible.Body>
            <CheckListFilterItems
              id={accessibilityId}
              filter={filter}
              onChange={onChange}
              format={format}
              lang={lang}
              buttonActiveText={buttonActiveText}
              buttonInactiveText={buttonInactiveText}
              className='mxd-mcollapse-body mxd-mcollapse-list'
              expandableClassName='mxd-mcollapse-list'
              filterPosition='side'
            />
          </Collapsible.Body>
        )}
      </AnimatePresence>
    </Collapsible>
  )
}

export function getSelectedWithToggle(items, item) {
  let wasItemPresent = false
  const selectedItems = items.filter(i => {
    if (i.checked && i.value === item.value) {
      wasItemPresent = true
      return false
    }
    return i.checked
  })

  return { selectedItems, wasItemPresent }
}

export const onSelectFilter = ({ filter, filterPosition, onChange, getSelectedWithToggleFunc, availabilityItem }) => {
  return ({ item } = {}) => {
    item = item || availabilityItem
    const { id, type, title, name, items, fullName } = filter
    const { selectedItems, wasItemPresent } = getSelectedWithToggleFunc(items, item)

    if (!wasItemPresent) selectedItems.push(item)
    onChange({
      id,
      fullName,
      name,
      items: selectedItems,
      item: { ...item, checked: !item.checked },
      type,
      title,
      filterPosition
    })
  }
}
